import {
  CLIENT_CALENDAR,
  CLIENT_CHAT_MESSAGE,
  CLIENT_DEPOSIT,
  CLIENT_DEPOSIT_BATCH,
  CLIENT_EXCHANGE_RATES_LATEST,
  CLIENT_EXCHANGE_RATES_TIME,
  CLIENT_SUBSCRIBE_EVENT,
  CLIENT_SUBSCRIBE_MARKET,
  CLIENT_SUBSCRIBE_TOURNAMENT,
  CLIENT_TICKET,
  CLIENT_TOP_GAMES,
  CLIENT_UPCOMING_GAMES,
  CLIENT_WALLET,
  CLIENT_WITHDRAWAL,
  CLIENT_WITHDRAWAL_BATCH,
  SERVER_CALENDAR,
  SERVER_CHAT_MESSAGE,
  SERVER_DEPOSIT,
  SERVER_EXCHANGE_RATES_LATEST,
  SERVER_EXCHANGE_RATES_TIME,
  SERVER_GAME_EVENT,
  SERVER_MARKET,
  SERVER_TICKET,
  SERVER_TOP_GAMES,
  SERVER_TOURNAMENT,
  SERVER_UPCOMING_GAMES,
  SERVER_WALLET,
  SERVER_WITHDRAWAL,
  SERVER_WITHDRAWAL_BATCH,
} from "constants/events";
import { ClientsService, IMessagesFromServer, IMessagesToClient, SocketService } from "services";
import { IEventFeedResponse } from "utils/feed.storage.types";
import { EventHandlingStrategy } from "./abstract.strategy";
import { IFeedResponse } from "utils/feed.server.types";

export class DefaultStrategy extends EventHandlingStrategy {
  constructor(clientsService: ClientsService, socketService: SocketService) {
    super(clientsService, socketService);
  }

  static getEvents(): [IMessagesToClient, IMessagesFromServer["event"]][] {
    return [
      [CLIENT_DEPOSIT, SERVER_DEPOSIT],
      [CLIENT_DEPOSIT_BATCH, CLIENT_DEPOSIT_BATCH],
      [CLIENT_WITHDRAWAL, SERVER_WITHDRAWAL],
      [CLIENT_WITHDRAWAL_BATCH, SERVER_WITHDRAWAL_BATCH],
      [CLIENT_EXCHANGE_RATES_LATEST, SERVER_EXCHANGE_RATES_LATEST],
      [CLIENT_EXCHANGE_RATES_TIME, SERVER_EXCHANGE_RATES_TIME],
      [CLIENT_TICKET, SERVER_TICKET],
      [CLIENT_CHAT_MESSAGE, SERVER_CHAT_MESSAGE],
      [CLIENT_WALLET, SERVER_WALLET],
      [CLIENT_SUBSCRIBE_MARKET, SERVER_MARKET],
      [CLIENT_SUBSCRIBE_EVENT, SERVER_GAME_EVENT],
      [CLIENT_SUBSCRIBE_TOURNAMENT, SERVER_TOURNAMENT],
      [CLIENT_CALENDAR, SERVER_CALENDAR],
      [CLIENT_TOP_GAMES, SERVER_TOP_GAMES],
      [CLIENT_UPCOMING_GAMES, SERVER_UPCOMING_GAMES],
    ];
  }

  private getEventsFromFeedResponse(response: IFeedResponse): IEventFeedResponse[] {
    const events: IEventFeedResponse[] = [];

    for (const sport of response.sports) {
      for (const category of sport.categories) {
        for (const tournament of category.tournaments) {
          for (const event of tournament.events) {
            events.push({
              ...event,
              sport_id: sport.id,
              sport_name: sport.name,
              sport_slug: sport.slug,
              category_id: category.id,
              category_name: category.name,
              tournament_id: tournament.id,
              tournament_name: tournament.name,
              tournament_is_top: tournament.is_top,
              tournament_top_index: tournament.top_index,
            } as unknown as IEventFeedResponse);
          }
        }
      }
    }
    return events;
  }

  private getDataFromResponse(clientEvent: IMessagesToClient | undefined, rid: string, response: IMessagesFromServer) {
    switch (clientEvent) {
      case CLIENT_SUBSCRIBE_EVENT:
        const events = this.getEventsFromFeedResponse(response.data);
        return {
          rid,
          ...events[0],
        };
      case CLIENT_SUBSCRIBE_TOURNAMENT:
      case CLIENT_TOP_GAMES:
      case CLIENT_UPCOMING_GAMES:
      case CLIENT_CALENDAR:
        return this.getEventsFromFeedResponse(response.data);
      default:
        return response.data;
    }
  }

  handleServerMessage(response: IMessagesFromServer) {
    if (!this.subscriptionsStorage.isSubscriptionExist(response.rid)) {
      return;
    }

    const clientEventName = this.subscriptionsStorage.getEventNameByRid(response.rid) as IMessagesToClient;
    const data = this.getDataFromResponse(clientEventName, response.rid, response);
    this.clientsService.sendClientMessage(response.rid, data);
  }
}
